module.exports = __webpack_public_path__ + "static/HSE_logo-e32523504750bc9a1c63ab5da11b1523.png";